export default __webpack_public_path__ + "static/media/paypal.04ad8f89.svg";